/**
 * This function moves the user to the end of the form.
 * @param {Object} state - The current state of the form.
 * @returns {Object} - The updated state of the form with the current step moved to the end.
 * @description This function is really only used for testing.
 */
export default function moveToEndOfForm(state) {
  return { ...state, currentStepIndex: state.formConfigs.steps.length - 1 };
}
